import { userConstants } from "../actions/constants/userConstants";
import { success, failure, request } from "@/utils/constants";

interface UserState {
    users: {
        data: any[];
        total: number;
    } | null;
    loading: boolean;
    error: string | null;
}

const initialState: UserState = {
    users: null,
    loading: false,
    error: null,
};

export const userReducer = (state = initialState, action: any): UserState => {
    switch (action.type) {
        case userConstants.listUsersRequest:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case userConstants.listUsersSuccess:
            return {
                ...state,
                loading: false,
                users: action.payload,
                error: null,
            };
        case userConstants.listUsersFailure:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case userConstants.inviteUserRequest:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case userConstants.inviteUserSuccess:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case userConstants.inviteUserFailure:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case userConstants.listUsersReset:
            return {
              users: null,
              loading: false,
              error: null,
            };
        default:
            return state;
    }
};

export const viewUserReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.viewUserRequest:
            return {
                ...request,
            };
        case userConstants.viewUserSuccess:
            return {
                ...success,
                userDetails: action.payload,
            };
        case userConstants.viewUserFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};

export const editUserReducer = (state = {}, action: any) => {
    switch (action.type) {
        case userConstants.editUserRequest:
            return {
                ...request,
            };
        case userConstants.editUserSuccess:
            return {
                ...success,
                userDetails: action.payload,
            };
        case userConstants.editUserFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
interface UserListState {
  users: {
    data: any[];
    total: number;
  } | null;
  loading: boolean; 
  success: boolean; 
  error: string | null;
}

const userListInitialState: UserListState = {
  users: null,
  loading: false,
  error: null,
  success:false
};

export const userListReducer = (state = userListInitialState, action: any): UserListState => {
  switch (action.type) {
    case userConstants.listUsersRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.listUsersSuccess:;
      return {
        ...state,
        loading: false,
        users: action.payload,
        success:true,
        error: null,
      };
    case userConstants.listUsersFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case userConstants.listUsersReset:
      return {
        ...userListInitialState,
      };
    default:
      return state;
  }
};

export const memberListReducer = (state = userListInitialState, action: any): UserListState => {
  switch (action.type) {
    case userConstants.listMembersRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.listMembersSuccess:
      return {
        ...state,
        loading: false,
        users: action.payload,
        success: true,
        error: null,
      };
    case userConstants.listMembersFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const photographerListReducer = (state = userListInitialState, action: any): UserListState => {
  switch (action.type) {
    case userConstants.listPhotographersRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.listPhotographersSuccess:
      return {
        ...state,
        loading: false,
        users: action.payload,
        success: true,
        error: null,
      };
    case userConstants.listPhotographersFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

interface InviteUserState {
  loading: boolean;
  error: string | null;
}

const inviteUserInitialState: InviteUserState = {
  loading: false,
  error: null,
};

export const inviteUserReducer = (state = inviteUserInitialState, action: any): InviteUserState => {
  switch (action.type) {
    case userConstants.inviteUserRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.inviteUserSuccess:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case userConstants.inviteUserFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

interface DeleteUserState {
  loading: boolean;
  error: any;
  success: boolean;
  message?: string;
}

const deleteUserInitialState: DeleteUserState = {
  loading: false,
  error: null,
  success: false,
  message: undefined,
};

export const deleteUserReducer = (state = deleteUserInitialState, action: any): DeleteUserState => {
  switch (action.type) {
    case userConstants.deleteUserRequest:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case userConstants.deleteUserSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        message: action.payload?.message,
      };
    case userConstants.deleteUserFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case userConstants.clearDeleteUserState:
      return deleteUserInitialState;
    default:
      return state;
  }
};

interface ProcessDeleteRequestState {
  loading: boolean;
  error: string | null;
}

const processDeleteRequestInitialState: ProcessDeleteRequestState = {
  loading: false,
  error: null,
};

export const processDeleteRequestReducer = (state = processDeleteRequestInitialState, action: any): ProcessDeleteRequestState => {
  switch (action.type) {
    case userConstants.processDeleteRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.processDeleteSuccess:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case userConstants.processDeleteFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case userConstants.clearProcessDeleteState:
      return processDeleteRequestInitialState;
    default:
      return state;
  }
};

interface DeleteRequestsListState {
  deleteRequests: {
    data: any[];
    total: number;
  } | null;
  loading: boolean;
  error: string | null;
}

const deleteRequestsListInitialState: DeleteRequestsListState = {
  deleteRequests: null,
  loading: false,
  error: null,
};

export const deleteRequestsListReducer = (state = deleteRequestsListInitialState, action: any): DeleteRequestsListState => {
  switch (action.type) {
    case userConstants.listDeleteRequestsRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.listDeleteRequestsSuccess:
      return {
        ...state,
        loading: false,
        deleteRequests: action.payload,
        error: null,
      };
    case userConstants.listDeleteRequestsFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

interface RevokeUserState {
  loading: boolean;
  error: any;
  success: boolean;
  message?: string;
}

const revokeUserInitialState: RevokeUserState = {
  loading: false,
  error: null,
  success: false,
  message: undefined,
};

export const revokeUserReducer = (state = revokeUserInitialState, action: any): RevokeUserState => {
  switch (action.type) {
    case userConstants.revokeUserRequest:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case userConstants.revokeUserSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        message: action.payload?.message,
      };
    case userConstants.revokeUserFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case userConstants.clearRevokeUserState:
      return revokeUserInitialState;
    default:
      return state;
  }
};

interface SubmitUpdateRequestState {
  loading: boolean;
  error: any;
  success: boolean;
  result?: any;
}

const submitUpdateRequestInitialState: SubmitUpdateRequestState = {
  loading: false,
  error: null,
  success: false,
  result: undefined,
};

export const submitUpdateRequestReducer = (state = submitUpdateRequestInitialState, action: any): SubmitUpdateRequestState => {
  switch (action.type) {
    case userConstants.submitUpdateRequestRequest:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case userConstants.submitUpdateRequestSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        result: action.payload,
      };
    case userConstants.submitUpdateRequestFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case userConstants.clearSubmitUpdateRequestState:
      return submitUpdateRequestInitialState;
    default:
      return state;
  }
};

interface ProcessUpdateRequestState {
  loading: boolean;
  error: any;
  success: boolean;
}

const processUpdateRequestInitialState: ProcessUpdateRequestState = {
  loading: false,
  error: null,
  success: false,
};

export const processUpdateRequestReducer = (state = processUpdateRequestInitialState, action: any): ProcessUpdateRequestState => {
  switch (action.type) {
    case userConstants.processUpdateRequestRequest:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case userConstants.processUpdateRequestSuccess:
      return {
        loading: false,
        error: null,
        success: true,
      };
    case userConstants.processUpdateRequestFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case userConstants.clearProcessUpdateRequestState:
      return processUpdateRequestInitialState;
    default:
      return state;
  }
};

interface UpdateRequestsListState {
  data: {
    data: any[];
    total: number;
  } | null;
  loading: boolean;
  error: string | null;
}

const updateRequestsListInitialState: UpdateRequestsListState = {
  data : null,
  loading: false,
  error: null,
};

export const updateRequestsListReducer = (state = updateRequestsListInitialState, action: any): UpdateRequestsListState => {
  switch (action.type) {
    case userConstants.listUpdateRequestsRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.listUpdateRequestsSuccess:
      return {
        loading: false,
        data : action.payload,
        error: null,
      };
    case userConstants.listUpdateRequestsFailure:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const viewKycReducer = (state = {}, action: any) => {
  switch (action.type) {
    case userConstants.viewKycdocumentRequest:
      return {
        ...request,
      };
    case userConstants.viewKycdocumentSuccess:
      return {
        ...success,
        kycDocument: action.payload,
      };  
    case userConstants.viewKycdocumentFailure:
      return {
        ...failure,
      };
    default:
      return state;
  }
};